import React from "react";
import { Link } from "react-router-dom";
import { useServices } from "../../services/servicesService";
import { generateSlug } from "../../utils/slugUtils";

function FooterTwo() {
  const { data: featuredServices = [] } = useServices();

  return (
    <div>
      <>
        {/* footer area start */}
        <div
          className="rts-footer-area rts-section-gap footer-two footer-bg-two mt--120 mt_md--80 mt_sm--60"
          id="f-contact"
        >
          <div className="container">
            <div className="row">
              {/* single wized */}
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="footer-two-single-wized left">
                  <h3 className="title">
                    <span>Ready to</span> <br />
                    Build With Precision?
                  </h3>
                  <p className="disc">
                    Talk to our multidisciplinary engineering team to accelerate
                    your analyser systems, hydrogen programs, or industrial
                    automation roadmap.
                  </p>
                  <Link
                    className="rts-btn btn-primary-2 color-h-black"
                    to={"/contactus"}
                  >
                    Start a Conversation
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt_sm--50">
                <div className="footer-two-single-wized two">
                  <div className="wized-title-area">
                    <h5 className="wized-title">Our Services</h5>
                    <p
                      style={{
                        border: "1px dashed #DF0A0A",
                        width: "60%",
                        marginTop: "10px",
                      }}
                    />
                  </div>
                  <div className="wized-2-body">
                    <ul>
                      {featuredServices.map((service) => (
                        <li key={service.name}>
                          <Link to={`/services/${generateSlug(service.name)}`}>
                            <i className="fal fa-chevron-double-right" />
                            {service.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* single wized */}
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mt_sm--30 mt_lg--30 mt_md--30">
                <div className="footer-two-single-wized">
                  <div className="wized-title-area">
                    <h5 className="wized-title">Contact Us</h5>
                    <p
                      style={{
                        border: "1px dashed #DF0A0A",
                        width: "60%",
                        marginTop: "10px",
                      }}
                    />
                  </div>
                  <div className="wized-2-body">
                    <div className="contact-info-1">
                      <div className="icon">
                        <i className="fas fa-phone-alt" />
                      </div>
                      <div className="disc" style={{ flex: 1, minWidth: 0 }}>
                        <span>Call Us 24/7</span>
                        <Link to={"tel:+91-422-23419872"}>
                          +91-422-23419872
                        </Link>
                      </div>
                    </div>
                    <div className="contact-info-1">
                      <div className="icon">
                        <i className="fas fa-envelope" />
                      </div>
                      <div className="disc" style={{ flex: 1, minWidth: 0 }}>
                        <span>Email Us</span>
                        <Link
                          to={"mailto:enquiry@sembian.net"}
                          style={{
                            wordBreak: "break-word",
                            fontSize: "clamp(14px, 2vw, 16px)",
                            lineHeight: "1.4",
                            display: "block",
                            maxWidth: "100%",
                            overflowWrap: "break-word",
                          }}
                        >
                          enquiry@sembian.net
                        </Link>
                      </div>
                    </div>
                    <div className="contact-info-1">
                      <div className="icon">
                        <i className="fas fa-map-marker-alt" />
                      </div>
                      <div className="disc">
                        <span>Our Location</span>
                        <Link to={"/contactus"}>
                          Sembian Research & Engineering Pvt. Ltd. <br />
                          Coimbatore, Tamil Nadu, India
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* single wized */}
            </div>
          </div>
        </div>
        {/* footer area end */}
        {/* copyright-area start */}
        <div className="rts-copy-right ptb--30">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-h-2-wrapper">
                  <p className="disc">
                    Sembian Research & Engineering Pvt. Ltd. - Copyright{" "}
                    {new Date().getFullYear()}. All rights reserved.
                  </p>
                  <div className="right">
                    {/* <p className="disc">
                      Developed by{" "}
                      <Link
                        to={"https://www.saitechnosolutions.com"}
                        style={{ color: "#DF0A0A" }}
                        target="_blank"
                      >
                        Sai Techno Solutions
                      </Link>
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* copyright-area end */}
      </>
    </div>
  );
}

export default FooterTwo;
